/**
 * Border radius design tokens
 * Consistent border radius values used across all themes
 */
export const borderRadius = {
  none: '0rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
  full: '9999px',
} as const;

export type BorderRadiusKey = keyof typeof borderRadius;
